// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__G2Ryl","text":"Logo_text__3pm4b","text2":"Logo_text2__hhByY"};